<script setup>
import { ref } from 'vue'
import { getI18n } from '@/plugins/i18n'
import ConfirmDialog from '@/components/shared/ConfirmDialog.vue'

defineProps({
  item: {
    type: Object,
    required: true,
  },
  hideDelete: {
    type: Boolean,
    default: false,
  },
  dense: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['remove'])

const i18n = getI18n()

const showDeleteDialog = ref(false)

const onRemove = () => { showDeleteDialog.value = true }
</script>

<template>
  <q-item v-if="!dense">
    <q-item-section side>
      <q-icon name="mdi-link" />
    </q-item-section>
    <q-item-section class="url-text">
      <a
        :href="item.url"
        target="_blank"
        rel="noopener noreferrer"
        class="url-link"
      >{{ item.url }}</a>
    </q-item-section>
    <q-item-section side>
      <q-btn
        v-if="!hideDelete"
        round
        flat
        icon="mdi-delete"
        @click="onRemove"
      />
    </q-item-section>
  </q-item>
  <a
    v-else
    :href="item.url"
    target="_blank"
    rel="noopener noreferrer"
    class="link"
  >
    <q-icon name="mdi-link" size="xs" class="q-mr-xs" />{{ item.url }}
  </a>
  <confirm-dialog
    v-model="showDeleteDialog"
    :message="i18n.t('common.confirmDeleteMessage', { item: item.url })"
    icon="mdi-delete-outline"
    icon-color="negative"
    @confirm="emit('remove', item)"
  />
</template>

<style scoped lang="scss">
.url-link {
  color: $primary;
  text-decoration: none;
  word-break: break-all;
  font-size: 0.85rem;

  &:hover {
    text-decoration: underline;
  }
}

.link {
  display: block;
  color: $primary;
  cursor: pointer;
  font-weight: bold;
  text-decoration: none;
  word-break: break-all;

  &:not(:last-child) {
    margin-bottom: .25rem;
  }

  &:hover {
    text-decoration: underline;
  }
}
</style>
